"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEndpointGetUndelegations = exports.generateEndpointGetDelegations = exports.generateEndpointGetValidators = exports.generateEndpointDistributionRewardsByAddress = void 0;
function generateEndpointDistributionRewardsByAddress(address) {
    return `/cosmos/distribution/v1beta1/delegators/${address}/rewards`;
}
exports.generateEndpointDistributionRewardsByAddress = generateEndpointDistributionRewardsByAddress;
function generateEndpointGetValidators() {
    return `/cosmos/staking/v1beta1/validators`;
}
exports.generateEndpointGetValidators = generateEndpointGetValidators;
function generateEndpointGetDelegations(delegatorAddress) {
    return `/cosmos/staking/v1beta1/delegations/${delegatorAddress}`;
}
exports.generateEndpointGetDelegations = generateEndpointGetDelegations;
function generateEndpointGetUndelegations(delegatorAddress) {
    return `/cosmos/staking/v1beta1/delegators/${delegatorAddress}/unbonding_delegations`;
}
exports.generateEndpointGetUndelegations = generateEndpointGetUndelegations;
//# sourceMappingURL=staking.js.map